@if (usageOverviewDialog.pinnedToSidenav()) {
<div
    class="usage-overview-sidenav"
    [class.usage-overview-sidenav--loading]="usageOverviewDialog.loading()"
    role="button"
    tabindex="0"
    [attr.aria-label]="'billingStatusWidget.restore' | translate"
    [attr.aria-busy]="usageOverviewDialog.loading()"
    (click)="openOverview($event)"
    (keydown.enter)="openOverview($event)"
    (keydown.space)="openOverview($event); $event.preventDefault()">
    <div class="usage-overview-sidenav__header">
        <span class="usage-overview-sidenav__title">
            <mat-icon class="usage-overview-sidenav__pin-icon" aria-hidden="true">push_pin</mat-icon>
            {{ 'billingStatusWidget.minimizedTitle' | translate }}
        </span>
        @if (usageOverviewDialog.loading()) {
        <mat-progress-spinner
            class="usage-overview-sidenav__loader"
            color="primary"
            diameter="16"
            mode="indeterminate"
            [attr.aria-label]="'billingStatusWidget.loading' | translate" />
        } @else {
        <span
            class="usage-overview-sidenav__count"
            [attr.aria-label]="
                'billingStatusWidget.minimizedClaims'
                    | translate: tParams({ count: claimCount() })
            ">
            {{ claimCount() }}
        </span>
        }
    </div>
    @if (!usageOverviewDialog.loading()) {
    <div
        class="usage-overview-sidenav__progress"
        role="progressbar"
        [attr.aria-valuenow]="progressPercent()"
        aria-valuemin="0"
        aria-valuemax="100">
        <span
            class="usage-overview-sidenav__progress-fill"
            [style.width.%]="progressPercent()"></span>
    </div>
    }
    <div
        class="usage-overview-sidenav__footer"
        [class.usage-overview-sidenav__footer--cancellation]="
            !usageOverviewDialog.loading() && cancellationPending()
        ">
        @if (!usageOverviewDialog.loading()) {
            @if (cancellationPending()) {
            <div class="usage-overview-sidenav__footer-meta">
                <span
                    class="usage-overview-sidenav__tier-badge usage-overview-sidenav__tier-badge--cancel"
                    matTooltipClass="usage-overview-widget-tooltip"
                    [matTooltip]="
                        'billingStatusWidget.summary.cancelEndsHint'
                            | translate: tParams({ date: cancellationEndDateLabel()! })
                    ">
                    {{ 'billingStatusWidget.pinnedCancelScheduled' | translate }}
                </span>
                <button
                    type="button"
                    class="usage-overview-sidenav__keep-button"
                    [disabled]="
                        usageOverviewDialog.loading() || reverseCancellation.reversing()
                    "
                    [matTooltip]="'billingStatusWidget.reverseCancellation.button' | translate"
                    [attr.aria-label]="'billingStatusWidget.reverseCancellation.button' | translate"
                    (click)="keepService($event)">
                    {{ 'billingStatusWidget.pinnedKeepService' | translate }}
                </button>
            </div>
            } @else {
                @if (currentServicePlan(); as plan) {
                <span class="usage-overview-sidenav__tier-badge">
                    {{
                        'billingStatusWidget.usage.tierMarker'
                            | translate: tParams({
                                tier: plan.tier,
                                threshold: tierMarkerThreshold()!
                            })
                    }}
                </span>
                }
            }
        }
        <div class="usage-overview-sidenav__actions">
            <button
                type="button"
                class="usage-overview-sidenav__icon-button"
                [matTooltip]="'billingStatusWidget.refresh' | translate"
                [disabled]="usageOverviewDialog.loading()"
                [attr.aria-label]="'billingStatusWidget.refresh' | translate"
                (click)="refresh($event)">
                <mat-icon>refresh</mat-icon>
            </button>
            <button
                type="button"
                class="usage-overview-sidenav__icon-button"
                [matTooltip]="'billingStatusWidget.unpinFromSidenav' | translate"
                [attr.aria-label]="'billingStatusWidget.unpinFromSidenav' | translate"
                (click)="unpin($event)">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>
}
